import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, Carousel } from 'react-bootstrap';
import Mug from '../assets/BKFMug.jpg';
import mugms from '../assets/MugInHand.jpeg';
import mugos from '../assets/MugInside.jpeg';
import mugi from '../assets/mugcomparison.jpeg';

// [min px, % of window width, max px] - change sizes here only
const TITLE = [18, 2.4, 26];
const DESC = [15, 1.7, 20];
const fitPx = ([min, pct, max]) =>
  Math.min(max, Math.max(min, (window.innerWidth * pct) / 100)) + "px";
const clampCSS = ([min, pct, max]) => `clamp(${min}px, ${pct}vw, ${max}px)`;

function syncSizes() {
  const title = fitPx(TITLE);
  const desc = fitPx(DESC);
  const css =
    `.shopify-buy__product__title{font-size:${title} !important}` +
    `.shopify-buy__product__price,.shopify-buy__product__price *,.shopify-buy__btn{font-size:${desc} !important}`;
  ['collection-component-newarrivals', 'collection-component-1779337570360'].forEach(function (id) {
    const root = document.getElementById(id);
    if (!root) return;
    root.querySelectorAll('iframe').forEach(function (frame) {
      let doc = null;
      try { doc = frame.contentDocument; } catch (e) { return; }
      if (!doc || !doc.head) return;
      let tag = doc.getElementById('size-sync');
      if (!tag) {
        tag = doc.createElement('style');
        tag.id = 'size-sync';
        doc.head.appendChild(tag);
      }
      if (tag.textContent !== css) tag.textContent = css;
    });
  });
}

function Merch() {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const initialized = useRef(false);
  const TITLE_SIZE = fitPx(TITLE);
  const DESC_SIZE = fitPx(DESC);

useEffect(() => {
    if (initialized.current) return;
  initialized.current = true;
  const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

  // Writes the same pixel size into every product card, live, no redraw

  function ShopifyBuyInit() {
    const client = window.ShopifyBuy.buildClient({
      domain: '9vqm95-hj.myshopify.com',
      storefrontAccessToken: 'f3c9815ddf9bf89e883d3344acc2deb6',
    });

    window.ShopifyBuy.UI.onReady(client).then(function (ui) {
      const collectionOptions = {
          "product": {
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "calc(33.33333% - 30px)",
                  "margin-left": "30px",
                  "margin-bottom": "50px",
                  "width": "calc(33.33333% - 30px)"
                },
                "img": {
                  "height": "calc(100% - 15px)",
                  "position": "absolute",
                  "left": "0",
                  "right": "0",
                  "top": "0",
                  "border-radius": "9px"
                },
                "imgWrapper": {
                  "padding-top": "calc(75% + 15px)",
                  "position": "relative",
                  "height": "0"
                }
              },
              "title": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "font-size": TITLE_SIZE,
                "color": "#f3ae3d"
              },
            "button": {
              "font-family": "Oswald, sans-serif",
              "font-weight": "bold",
              "font-size": DESC_SIZE,
              "color": "#f3ae3d",
              "background-color": "#141313",
              "border-radius": "12px",
              "border": "2px solid rgba(243,174,61,0.8)",
              ":hover": {
                "color": "#f3ae3d",
                "background-color": "#222020"
              },
              ":focus": {
                "background-color": "#222020",
                "outline": "none"
              }
            },
              "price": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "font-size": DESC_SIZE,
                "color": "#f3ae3d"
              },
              "compareAt": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "color": "#f3ae3d"
              },
              "unitPrice": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "font-size": DESC_SIZE,
                "color": "#f3ae3d"
              }
            },
            "text": {
              "button": "Add to Cart",
            },
            "googleFonts": ["Oswald"]
          },
          "productSet": {
            "styles": {
              "products": {
                "@media (min-width: 601px)": {
                  "margin-left": "-30px",
                  "font-size": DESC_SIZE,
                }
              }
            }
          },
          "modalProduct": {
            "contents": {
              "img": false,
              "imgWithCarousel": true,
              "button": false,
              "buttonWithQuantity": true
            },
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px",
                  "font-size": DESC_SIZE,
                }
              },
              "button": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "font-size": DESC_SIZE,
                "color": "#f3ae3d",
                ":hover": {
                  "color": "#f3ae3d",
                  "background-color": "#222020"
                },
                "background-color": "#141313",
                ":focus": {
                  "background-color": "#222020",
                  "outline": "none"
                },
                "border-radius": "9px"
              },
              "title": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "bold",
                "font-size": DESC_SIZE,
                "color": "#4c4c4c"
              },
              "price": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": DESC_SIZE,
                "color": "#4c4c4c"
              },
              "compareAt": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": DESC_SIZE,
                "color": "#4c4c4c"
              },
              "unitPrice": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": DESC_SIZE,
                "color": "#4c4c4c"
              }
            },
            "googleFonts": ["Quantico"],
            "text": {
              "button": "Add to cart"
            }
          },
         "option": {
          "styles": {
            "label": {
              "font-family": "Oswald, sans-serif",
              "font-weight": "bold"
            },
              "wrapper": {
                "width": "150px",
                "margin": "0 auto",
                "border": "none",
                "overflow": "hidden",
                "border-radius": "9px"
              },
                  "select": {
                    "font-family": "Oswald, sans-serif",
                    "font-weight": "bold",
                    "background-color": "#141313",
                    "color": "#f3ae3d",
                    "border": "2px solid #b32519",
                    "border-radius": "9px",
                    "width": "100%",
                    "outline": "none"
                  }
                },
                "googleFonts": ["Oswald"]
              },
          "cart": {
            "styles": {
              "button": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "color": "#f3ae3d",
                ":hover": {
                  "color": "#f3ae3d",
                  "background-color": "#222020",
                },
                "background-color": "#222020",
                ":focus": {
                  "background-color": "#222020",
                  "outline": "none"
                },
                "border-radius": "9px"
              },
              "title": { "color": "#f3ae3d" },
              "header": { "color": "#f3ae3d" },
              "lineItems": { "color": "#f3ae3d" },
              "subtotalText": { "color": "#f3ae3d" },
              "subtotal": { "color": "#f3ae3d" },
              "notice": { "color": "#f3ae3d" },
              "currency": { "color": "#f3ae3d" },
              "close": {
                "color": "#f3ae3d",
                ":hover": { "color": "#f3ae3d" }
              },
              "empty": { "color": "#f3ae3d" },
              "noteDescription": { "color": "#f3ae3d" },
              "discountText": { "color": "#f3ae3d" },
              "discountIcon": { "fill": "#f3ae3d" },
              "discountAmount": { "color": "#f3ae3d" },
              "cart": { "background-color": "#161616" },
              "footer": { "background-color": "#141313" }
            },
            "text": {
              "total": "Subtotal",
              "button": "Checkout"
            },
            "googleFonts": ["Oswald"]
          },
          "toggle": {
            "styles": {
              "toggle": {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "background-color": "#141313",
                ":hover": { "background-color": "#222020" },
                ":focus": { "background-color": "#222020" },
                "outline": "none"
              },
              "count": {
                "color": "#f3ae3d",
                ":hover": { "color": "#f3ae3d" }
              },
              "iconPath": { "fill": "#f3ae3d" }
            },
            "googleFonts": ["Oswald"]
          },
          "lineItem": {
            "styles": {
              "variantTitle": { "color": "#f3ae3d" },
              "title": { "color": "#f3ae3d" },
              "price": { "color": "#f3ae3d" },
              "fullPrice": { "color": "#f3ae3d" },
              "discount": { "color": "#f3ae3d" },
              "discountIcon": { "fill": "#f3ae3d" },
              "quantity": { "color": "#f3ae3d" },
              "quantityIncrement": { "color": "#f3ae3d", "border-color": "#f3ae3d" },
              "quantityDecrement": { "color": "#f3ae3d", "border-color": "#f3ae3d" },
              "quantityInput": { "color": "#f3ae3d", "border-color": "#f3ae3d" }
            }
          }
      };


      const newArrivalsOptions = JSON.parse(JSON.stringify(collectionOptions));
      newArrivalsOptions.product.contents = {
        img: false,
        imgWithCarousel: false,
        title: false,
        price: true,
        options: true,
        button: true,
      };
      newArrivalsOptions.product.styles.product = {
        "text-align": "center",
        "@media (min-width: 601px)": {
          "max-width": "800px",
          "margin-left": "auto",
          "margin-right": "auto",
          "margin-bottom": "50px",
          "width": "100%"
        }
      };
      newArrivalsOptions.productSet.styles.products = {
        "@media (min-width: 601px)": {
          "margin-left": "0px"
        }
      };

      // Main collection, then New Arrivals once the first is done
      Promise.resolve(
        ui.createComponent('collection', {
          id: '340625490070',
          node: document.getElementById('collection-component-1779337570360'),
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: JSON.parse(JSON.stringify(collectionOptions)),
        })
      ).then(function () {
        return ui.createComponent('collection', {
          id: '510066557078',
          node: document.getElementById('collection-component-newarrivals'),
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: newArrivalsOptions,
        });
      }).catch(function (err) {
        console.error('Buy Button error:', err);
      });
    });
  }

  if (window.ShopifyBuy?.UI) {
    ShopifyBuyInit();
  } else {
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    script.onload = ShopifyBuyInit;
    document.head.appendChild(script);
  }



  return () => {

    const existing = document.querySelector(`script[src="${scriptURL}"]`);
    if (existing) existing.remove();

      const node = document.getElementById('collection-component-1779337570360');
  if (node) node.innerHTML = '';
      const node2 = document.getElementById('collection-component-newarrivals');
  if (node2) node2.innerHTML = '';
  };
}, []);

useEffect(() => {
  syncSizes();
  window.addEventListener('resize', syncSizes);
  const syncTimer = setInterval(syncSizes, 250);
  return () => {
    window.removeEventListener('resize', syncSizes);
    clearInterval(syncTimer);
  };
}, []);




  const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  return (
    <div>
    <style>{`@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&display=swap');`}</style>
       <div
       style={{
          marginTop: '10%'
        }}
       > 

          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1,
            }}
              >
                <source 
                // src={BG} type="video/mp4" 
                 src={`${CF_BASE}/public/backgroundgrey2.mp4`} 
                />
                Your browser does not support the video tag.
            </video>
       <h1 className="justify-content-center"
       style={{
        // marginTop: '50px',
        marginBottom: '5%',
       WebkitTextStroke: '2px rgb(243, 174, 61)', // <-- outline around letters
            color: 'black', }}
       > 
       Shop Brass Knuckle</h1>
            </div>

    <div style={{ textAlign: 'center', marginBottom: '3%' }}>
      <h1
        style={{
          display: 'inline-block',
          WebkitTextStroke: '2px rgb(243, 174, 61)',
          color: 'black',
        }}
      >
        New Arrival!
      </h1>
    </div>
       <div style={{         width: "min(100%, clamp(320px, 55vw, 700px))", margin: "0 auto 10px" }}>
      <Carousel interval={null} indicators={false}>
        {[mugms, mugos, mugi].map((img, idx) => (
          <Carousel.Item key={idx}>
            <img
              src={img}
              alt="Brass Knuckle Mug"
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                borderRadius: "15px",
              }}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
    <div
      style={{
                width: "min(100%, clamp(320px, 55vw, 700px))",
        margin: "0 auto 10px",
        textAlign: "center",
        color: "#f3ae3d",
        fontFamily: "Oswald, sans-serif",
        fontWeight: "bold",
        fontSize: clampCSS(TITLE),
      }}
    >
      Brass Knuckle Films Mug
    </div>

    <div
      style={{
        width: "clamp(280px, 45vw, 700px)",
        boxSizing: "border-box",
        margin: "0 auto 20px",
        padding: "clamp(12px, 2vmax, 24px)",
        background: "rgba(20, 19, 19, 0.7)",
        borderRadius: "15px",
        textAlign: "left",
        color: "#f3ae3d",
        fontFamily: "Helvetica Neue, Arial, sans-serif",
        fontSize: clampCSS(DESC),
        lineHeight: "1.6",
        whiteSpace: "pre-line",
      }}
    >
      {`The Brass Knuckle Mug. A true statement piece- bold and built to impress friends and onlookers alike. Impossible to lose, impossible to ignore. Pour your coffee, make an entrance.

Size: 28oz`}
    </div>
    <div id='collection-component-newarrivals'></div>


    <div style={{ textAlign: 'center', marginBottom: '3%', marginTop: '5%' }}>
      <h1
        style={{
          display: 'inline-block',
          WebkitTextStroke: '2px rgb(243, 174, 61)',
          color: 'black',
        }}
      >
        All Merch
      </h1>
    </div>
    <div id='collection-component-1779337570360'></div>

    <div style={{ marginBottom: '10%' }}></div>
    </div>
  );
}

export default Merch;